// extracted by mini-css-extract-plugin
export var downArrow = "_8d-0";
export var label = "_8d-1";
export var treatmentCard = "_8d-3";
export var upArrow = "_8d-2";